
import { JsonObject, JsonProperty } from 'json2typescript';
import { City } from './city';
import { Court } from './court';


@JsonObject('Circle')
export class Circle {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('court', Court, true)
    court: Court = null;

    @JsonProperty('court_id', Number, true)
    courtId: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('name_ar', String, true)
    nameAr = '';

    @JsonProperty('address', String, true)
    address = null;

    @JsonProperty('city_id', Number, true)
    cityId = undefined;

    @JsonProperty('city', City, true)
    city = null;

    @JsonProperty('phone', String, true)
    phone = null;

    @JsonProperty('fax', String, true)
    fax = null;

    get location(): string {
        let l = "";
        l = this.address ? this.address + ", " : "";
        l += this.city ? this.city.getName : "";
        return (this.address || this.city.getName) ? l : '—';
    }

    get getName() {
        return this.name || this.nameAr;
    }

    get courtName() {
        return this.court?.getName;
    }
}